import React from 'react';
import { usePermissions } from '../../contexts/PermissionsContext';
import { AppModule } from '../../types';
import { FiLock } from 'react-icons/fi';

interface ProtectedRouteProps {
  module: AppModule;
  requireWrite?: boolean;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ module, requireWrite, children }) => {
  const { hasRead, hasWrite, loading } = usePermissions();

  if (loading) {
    return (
      <div className="loader-wrapper">
        <div className="loader" />
      </div>
    );
  }

  const hasAccess = requireWrite ? hasWrite(module) : hasRead(module);

  if (!hasAccess) {
    return (
      <div className="no-access">
        <FiLock size={40} style={{ marginBottom: '16px', opacity: 0.2 }} />
        <h2>Brak dostepu</h2>
        <p>Nie masz uprawnien do tego modulu.</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
